module.exports = __webpack_public_path__ + "img/Nutrilon_MCM_C1_2022_Healthy_Kids_580x312_002.44f26f52.png";